import { render, staticRenderFns } from "./searchRecord.vue?vue&type=template&id=2552a7a7&scoped=true"
import script from "./searchRecord.vue?vue&type=script&lang=js"
export * from "./searchRecord.vue?vue&type=script&lang=js"
import style0 from "./searchRecord.vue?vue&type=style&index=0&id=2552a7a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2552a7a7",
  null
  
)

export default component.exports